// Libs
import { useContext, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import "./MainLayout.scss";

// Core
import { AppContext } from "../../contexts/AppContext";

// Components
import FooterComponent from "../../components/layouts/FooterComponent/FooterComponent";
import HeaderComponent from "../../components/layouts/HeaderComponent/HeaderComponent";


/**
 * Reusable Layout Page, which is the parent component rendered of all pages under the `/` routes.
 * @returns {JSX.Element}
 */
const MainLayout = () => {
    const {  langForText } = useContext(AppContext);

    const genFooterRoutes = (): { label: string, path: string }[] => {
        return [
            // { label: LAYOUT_TEXT.FOOTER_ROUTE_LBL_PRIVACY_POLICY, path: "/" },
            // { label: LAYOUT_TEXT.FOOTER_ROUTE_LBL_LEGAL_NOTICES, path: "/" },
            // { label: LAYOUT_TEXT.FOOTER_ROUTE_LBL_MEDIA_POLICY, path: "/" },
            // { label: LAYOUT_TEXT.FOOTER_ROUTE_LBL_CONTACTS, path: "/" },
            // { label: LAYOUT_TEXT.FOOTER_ROUTE_LBL_ACCESSIBILITY, path: "/" },
            // { label: LAYOUT_TEXT.FOOTER_ROUTE_LBL_ASSISTANCE, path: "/" },
        ];
    };

    const [state, setState] = useState({
        footerRoutesArr: genFooterRoutes()
    });

    // Detect language change in AppContext and react to it.
    useEffect(() => {
        setState((oldState) => {
            const newState = { ...oldState };
            newState.footerRoutesArr = genFooterRoutes();
            return newState;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [langForText]);

    return (
        <div className="MainLayout">
            <HeaderComponent />
                <main className="">
                    <Outlet />
                </main>
            <FooterComponent footerRoutesArr={state.footerRoutesArr} />
        </div>
    );
};

export default MainLayout;
